import styled from 'styled-components'
import NetworkFilter from '../shared/filters/NetworkFilter'
import TokenTypeFilter from '../shared/filters/TokenTypeFilter'

interface AccountHeaderProps {
  account: string
}

export default function AccountHeader({ account }: AccountHeaderProps) {
  return (
    <Section>
      <div>
        <TokenTypeFilter account={account} />
      </div>
      <div>
        <NetworkFilter />
      </div>
    </Section>
  )
}
const { Section } = {
  Section: styled.section`
    display: grid;
    grid-template-columns: 130px auto;
    gap: 20px;
    margin-bottom: 20px;

    @media (min-width: ${props => props.theme.viewport.desktop}) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;
      margin-bottom: ${props => props.theme.margin.medium};

      > div:nth-child(odd) {
        justify-content: left;
      }

      > div:nth-child(even) {
        justify-content: right;
      }
    }
  `
}
